export default "__VITE_ASSET__CHHLqTw5__"